import React, { useEffect, useRef, useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowRightTwoToneIcon from '@mui/icons-material/KeyboardArrowRightTwoTone';
import Loader from '../../assests/animation/Loader2.json';
import {
  AmazonIconSmall,
  CompetitiveAnalysis,
  CrossIcon,
  DeleteIcon,
  DownArrowIcon,
  FacebookLogo,
  FacebookLogoSmall,
  FlipkartIconSmall,
  GreenDownArrowIcon,
  InstagramIconSmall,
  NewsLogo,
  RedCrossIcon,
  RenameIcon,
  StyledAddIcon,
  X_icon,
  YouTubeRedIcon,
} from '../../Common/SvgIcon/CommonSvgIcons';
import styled from 'styled-components';
import PopUp from '../../Common/PopUp/PopUp';
import Button from '../../Common/Button/Button';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  ChatterActive,
  ChatterDelete,
  ChatterHibernate,
  chatterList,
  emptyCustomAnalysis,
  emptyCustomAnalysisResult,
  updateSearchQuery,
  updateSelectedDraft,
} from '../../store/redux/slices/chatterSlice';
import {
  TopicActive,
  TopicDelete,
  TopicHibernate,
  activeTopicList,
  createTopicSideBar,
  renameTitleForTopic,
  resetFlagFunc,
  searchTextEmpty,
  setFetchStatus,
  setFilterPayload,
  setPopUpActive,
  topicPreviewEmpty,
} from '../../store/redux/slices/topicSlice';
import Lottie from 'lottie-react/build';
import { setMessage } from '../../store/redux/slices/alertMessageSlice';
import {
  competitiveIntelligenceDelete,
  competitiveIntelligenceListChatter,
  competitiveIntelligenceListTopic,
  updateCiFilter,
  updateShowSideBar,
} from '../../store/redux/slices/competitiveIntelligenceSlice';
import { enterPriseDelete } from '../../store/redux/slices/enterpriseSlice';
import { getConfiguredAlerts } from '../../store/redux/slices/alertSlice';
import CrossButton from './CrossBtn';
import { AccountCircle } from '@mui/icons-material';
import { Tooltip } from '@mui/material';

const TabWrapper = styled.div`
  font-weight: 400;
  font-size: 18px;
  cursor: pointer;
  // color: #222;
  color: var(--Headlines, rgba(42, 136, 107, 1));
  width: 100%;

  //common style for Type1Wrapper and Type2Wrapper
  & > div {
    display: flex;
    justify-content: space-between;
    margin: 14px auto;
    width: 85%;
    padding: 3px 0px;
  font-family: inherit;
  }

  //style for arrow button
  & > div svg {
    // color: #353cf7;
    color: var(--Headlines, rgba(42, 136, 107, 1));
    border: 1px solid var(--lines-3, rgba(42, 136, 107, 1));
    padding: 2px 8px;
    // border: 0.5px solid #353cf7;
    border-radius: 5px;
    ${({ setActive, bgchange }) =>
    setActive.activeTab === setActive.id &&
    `color: #fff;
    //  background:#353cf7;
     background: ${bgchange ? bgchange : "linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%)"};

     `};
  }

  &:hover {
    // color: #0e01fe;
    color:var(--Headlines, rgba(42, 136, 107, 1));
  }

  // Active setting tab will have background white
  ${({ setActive, bgchange }) =>
    setActive.activeTab === setActive.id &&
    `
  // color: #353cf7;
     color: linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%);
    font-weight:600;
  `};
`;

const Type2Wrapper = styled.div`
  padding: 10px !important;
  border-radius: 10px;
  background: rgb(240 255 240);

  flex-direction: column;
  & > div svg {
    border: none;
  }
  ${({ setActive }) =>
    setActive.activeTab === setActive.id &&
    `
      // height: 100px; 
      padding: 10px !important; 
      border-radius: 10px;
      background: rgb(240 255 240); 
      
      & > div  svg{
        background: transparent;
      // background: rgba(174, 177, 252, 0.16);   
        border:none;  
      }
    `};
`;

const Header = styled.div`
  display: flex;
  text-align: left;
  margin: 5px 0px 10px 5px;
  justify-content: space-between;
  font-family: inherit;
  font-weight: 600;
`;

const Type2TabDiv = styled.div`
  display:flex;
  margin: 7px 10px;
  
  position: relative;

  & > .tabWith1 {
    width: 93%;
    transition: all 0.2s ease;
    height: 43px;
    display: flex;
    align-items: center;
    
  }
        
  .threedots {
    display: none;


    & > .crossButton{
    position: relative;
    top: 20%;
    // top:50%;
    right: -1%;
    transition: opacity 0.3s ease; /* Add transition for smooth visibility change */
    
    }
  }
  &:hover .threedots {
    display: inline-block;
  }
  & > .crossButton {
    // position: absolute;
    // display: none;
    // transform: translateY(-50%);
    // opacity: 0; /* Initially hide the cross button */
    // visibility: hidden; /* Ensure the element is not taking space */
  
  }
 &:hover > .crossButton {
    display: block;
    display: inline-block;
    visibility: visible; /* Show cross button on hover */
    opacity: 1;
    & svg {
      color: #fff !important;
      padding: 2px 4px !important;
    }
  }

  &:hover > .tabWith1 {
    width: 75%;
    background: linear-gradient(95.02deg, #a0d925 -65.35%, #006a68 100%);
    // width: 70%;
    color: #fff;
  }

  .tooltip {
    position: absolute;
    top: 110%; /* show above */
    left: 50%;
    transform: translateX(-50%);
    
    background: rgba(89, 88, 88, 1);
    color: rgba(255, 255, 255, 1);
    font-size: 12px;
    padding: 6px 10px;
    border-radius: 6px;
    white-space: nowrap;

    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;

    display: flex;
    align-items: center;
    gap: 6px;
    z-index:${(props) => (props?.zindexActive == true) ? '1' : '9999'};
    font-family:inherit;
    
    word-break: break-all;    
    max-width: 160px;
    width: max-content;
    min-height: 20px;
    white-space: normal;
  }

  &:hover .tooltip {
    opacity: 1;
  }
`;
const Type2Tabs = styled.div`
  // padding: 8px 0;
  position: relative;
  height: auto;
  font-family: inherit;
  display: flex;
  border-radius: 10px;
  border: 1px solid var(--lines-3, rgba(42, 136, 107, 1));
  // padding: 10px 5px 10px 10px;
  font-weight: 500;
  font-size: 16px;
  cursor: pointer;


  ${({ setSubTabActive }) =>
    setSubTabActive.active === setSubTabActive.id &&
    `color: #fff;
    background: linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%);
      & svg{
        color: #fff !important;
        padding:2px 4px !important;
      }
  `};

  /* 🔹 TOOLTIP */
  &[data-tooltip]:not([data-tooltip=""])::after {
    content: attr(data-tooltip);
    position: absolute;
    top: 73%; /* above the tab */
    left: 50%;
    transform: translateX(-50%);
    background: rgba(42, 41, 41, 0.9);
    color: #fff;
    padding: 6px 10px;
    font-size: 12px;
    white-space: nowrap;
    border-radius: 4px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    z-index: 0;
  }

  &[data-tooltip]:not([data-tooltip=""]):hover::after {
    opacity: 1;
  }
`;


const DeletePopupWrapper = styled.div`
  line-height: 1.3rem;

  & > svg {
    width: 60px;
    height: 60px;
  }

  & > p:nth-child(1) {
    color: #fc6758;
  }

  & > p:nth-child(3) {
    //User name that will be displayed in the popup window
    span {
      color: #222;
    }
  }

  // Cancel and Delete button containers
  & > div {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;

    & > button {
      width: 200px;
      height: 45px;
      margin: 0 10px;
    }
    & > button:nth-child(1) {
      background-color: #fff;
      color: #222;
      width: min-content;
      margin-right: 30px;
    }
  }

  & .selectContainer {
    display: flex;
    justify-content: center;
    & > div {
      width: 40%;
    }
  }
`;

const SearchBar = styled.input`
  /*  width: 100%; */
  padding: 8px;
  margin: 8px;
  border-radius: 4px;
  background: #fff;
  border: none;
  font-family: inherit;
  margin-bottom: 0px;
`;

const Tab3Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  /*  overflow-y: scroll; */

  font-family: inherit;
`;
const ScrollableWrapper = styled.div`
  ${({ setActive }) =>
    setActive.scrollable &&
    `overflow-y: scroll;
    max-height:560px;
    overflow-x:hidden;
    overflow: hidden auto;
    max-height: 758px;
    height: calc(100vh - 380px);
     `};
`;
const Line = styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  height: 1px;
  width: 100%;
  background: #dddddd;
`;

const Icon = styled.span`
  & > svg {
    height: 16px;
    width: min-content;
  }
`;

const TransformTextStyle = styled.div`
  line-height: 24px;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 110px;
  position: relative;
  cursor: pointer;

  /* 🔹 Tooltip */
  &[data-tooltip]:not([data-tooltip=""])::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(42, 41, 41, 0.9);
    color: #fff;
    padding: 6px 10px;
    font-size: 12px;
    white-space: nowrap;
    border-radius: 4px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    z-index: 999;
  }

  &[data-tooltip]:not([data-tooltip=""]):hover::after {
    opacity: 1;
  }
`;


const NewChatterTab = styled.div`

  height: 45px !important;
  padding: 0px 10px !important;
  margin: 8px 0px;
  height: 25px;
  width: 90%;
  display: flex;
  justify-content: space-between;
  font-family: inherit;
  align-items: center;
  border-radius: 8px;
  border: 1px solid var(--lines-3, rgba(42, 136, 107, 1));
  // border: 1px solid #353cf7;
  padding: 10px 5px 10px 5px;

  font-size: 16px;
  color: var(--Headlines, rgba(42, 136, 107, 1));
  & svg {
    color: var(--Headlines, rgba(42, 136, 107, 1)) !important;
  }
  background: linear-gradient(95.02deg, #a0d925 -65.35%, #006a68 100%);
  color: #fff !important;
  & svg {
    color: #fff !important;
    border: none !important;
    background: transparent !important;

  }
  ${({ isClicked }) =>
    isClicked === true &&
    `color: #fff;

     background: linear-gradient(95.02deg, #A0D925 -65.35%, #006A68 100%);
    // background: #353cf7;
    & svg{
      color: #fff !important;
    }
`};
`;

const Tabs = ({ active, value, name, buttonTitle, showDropDown='', setShowDropDown=()=>console.log("")} ) => {
  const navigate = useNavigate();
  const [bgchange, setBgChange] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);
  const [isHovered, setIsHovered] = useState(null);
  const [popup, setPopup] = useState(false);
  const inputRef = useRef(null);
  const [renameText, setRenameText] = useState('');
  const [editTitle, setEditTitle] = useState(false);
  const [popupId, setPopupId] = useState(null);
  const [isClicked, setClicked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openId, setOpenId] = useState(false);
  const [isOpen, setIsOpen] = useState(false);


  const { topicPreviewDataLoader ,zindexActive} = useSelector((state) => state.topicBuilder) || {};
  const { personalDetailsData } = useSelector((state) => state.tenantSetting);
  const { alertsList } = useSelector((state) => state.alert) || [];
  const dispatch = useDispatch();
  const { val, id, subTabs, path } = value;
  let activeTab = active;
  if (typeof active === 'object') {
    activeTab = active.tab;
  }

  // console.log(active,"active");
  let setActiveState = { activeTab, id };
  if (subTabs && subTabs.length > 3) {
    setActiveState.scrollable = true; // Add scrollable flag
  }
  const handleEditName = (index, val) => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    setEditTitle(index)
    setRenameText(val)

  }
  const handleScreen = (subTabId, id, pathFroMap) => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    dispatch(setFetchStatus())
    dispatch(setFilterPayload({}));
    dispatch(updateShowSideBar(''))
    dispatch(updateCiFilter(true))
    if (id != active.subTab) {
      dispatch(updateSearchQuery(''));
      dispatch(emptyCustomAnalysis());
      dispatch(emptyCustomAnalysisResult());
      dispatch(updateSelectedDraft(null));
      dispatch(searchTextEmpty());
      dispatch(topicPreviewEmpty());
      dispatch(resetFlagFunc(false));
      // setSearchQuery("");
    }
    if (subTabs) {
      setClicked(false);
      navigate(pathFroMap);
    } else if (buttonTitle === 'Compare') {
      setClicked(false);
      navigate('/competitiveIntelligence/create');
    } else {
      setClicked(false);
      navigate(path);
    }
  };

  const handleNewChatter = () => {
    if (topicPreviewDataLoader == true) {
      return;
    }
    dispatch(updateSearchQuery(''));
    dispatch(emptyCustomAnalysis());
    dispatch(emptyCustomAnalysisResult());
    dispatch(updateSelectedDraft(null));
    dispatch(searchTextEmpty());
    dispatch(topicPreviewEmpty());
    dispatch(resetFlagFunc(false));

    if (name === 'Chatter Tracker') {
      navigate('/chatter/create');
    }
    else if (buttonTitle === 'Compare') {

      dispatch(updateShowSideBar('topic'))
      navigate('/competitiveIntelligence/create')
    }
    else if (name === 'Topic Listening') {
      dispatch(setPopUpActive(true));

      navigate('/topic/create');
    }
    setClicked(true);
  };
  const handleChangeStatus = (val, hibe) => {
    if (!popupId) return;
    if (val == "Hibernated") {
      handleHibernate();

    } else {
      const matchedAlert = alertsList?.find(
        (i) => i?.job_id?.[0]?.job_id === popupId
      );

      if (matchedAlert) {
        setConfirmAction(val);
      } else {
        handleRemove()
      }

    }


  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target)) {
        setEditTitle(null); // close input
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

  }, []);

  const filteredSubTabs = subTabs
    ? subTabs.filter((tab) =>
      tab.val.toLowerCase().includes(searchQuery.toLowerCase())
    )
    : [];

  useEffect(() => {
    setBgChange(personalDetailsData?.is_custom == 'custom' && personalDetailsData?.selected_items ? personalDetailsData?.selected_items : null)

  }, [personalDetailsData])

  useEffect(() => {
    // console.log(value, 'tabs')
  }, [value]);

  const handleDeleteSubTab = (id) => {

    if (topicPreviewDataLoader == true) {
      return;
    }
    setIsOpen(true)
    setPopup(!popup);
    setPopupId(id);
  };

  const handleClosePopup = () => {
    setPopup(false);
    setIsOpen(false);
  };


  const handleRemove = () => {
    setLoading(true);
    const jobId = popupId;
    // if (name === 'Chatter Tracker') {
    //   dispatch(ChatterDelete(jobId));
    // } else {
    //   dispatch(TopicDelete(jobId));
    // }

    const action =
      name === 'Chatter Tracker'
        ? ChatterDelete(jobId)
        : name === 'Competitive Analysis'
          ? competitiveIntelligenceDelete(jobId)
          : name === 'Enterprise Data'
            ? enterPriseDelete(jobId)
            : TopicDelete(jobId);

    dispatch(action)
      .then(() => {
        if (name === 'Competitive Analysis') {
          dispatch(competitiveIntelligenceListTopic());
          dispatch(competitiveIntelligenceListChatter());
        }
        dispatch(chatterList());
        dispatch(activeTopicList());
        setTimeout(() => {
          setLoading(false);

          setPopup(false);
          if (name === 'Chatter Tracker') {
            navigate('/chatter/home');
          } else if (name === 'Competitive Analysis') {
            navigate('/competitiveIntelligence/home');
          } else if (name === 'Enterprise Data') {
            navigate('/enterprise/home');

          } else {
            navigate('/topic/home');
          }

          // window.location.reload();
        }, 2000);
      })
      .catch((error) => {
        // Handle any error case here
        console.error('Error dispatching action:', error);
        const message =
          (error.response &&
            error.response.data &&
            (error.response.data.detail || error.response.data.message)) ||
          error.message ||
          error.toString();
        dispatch(setMessage(message));
      });
  };

  const handleHibernate = (subtabId) => {
    // Extract the ID of the subtab
    setLoading(true);
    const jobId = popupId;

    const action =
      name === 'Chatter Tracker'
        ? val === 'Hibernated'
          ? ChatterActive(jobId)
          : ChatterHibernate(jobId)
        : val === 'Hibernated'
          ? TopicActive(jobId)
          : TopicHibernate(jobId);

    dispatch(action)
      .then(() => {
        // Handle the success case here setLoading(true);
        dispatch(chatterList());
        dispatch(activeTopicList());
        setTimeout(() => {
          setLoading(false);
          // window.location.reload();
          setPopup(false);
        }, 2000);
      })
      .catch((error) => {
        // Handle any error case here
        console.error('Error dispatching action:', error);
        const message =
          (error.response &&
            error.response.data &&
            (error.response.data.detail || error.response.data.message)) ||
          error.message ||
          error.toString();
        dispatch(setMessage(message));
      });
  };

  const transformText = (inputText) => {
    const words = inputText?.split(' ');
    const transformedWords = words?.map(
      (word) => word?.charAt(0).toUpperCase() + word?.slice(1)
    );
    return transformedWords?.join(' ');
  };
  const handleRenameSubmit = (val) => {
    dispatch(renameTitleForTopic({
      topic_title: renameText,
      job_id: val
    }))

  }
  
  return (
    <>
      {popup && (
        <PopUp onClose={handleClosePopup}>
          {loading === true ? (
            <div >
              <div
                style={{
                  width: '50%',
                  height: '50%',
                  marginLeft: 'auto',
                  marginRight: 'auto',
                }}
              >
                <Lottie
                  data-testid='loader'
                  animationData={Loader}
                  loop={true}
                  width='100px'
                  height='100px'
                />
              </div>
            </div>
          ) : (
            <DeletePopupWrapper>
              <p>{RedCrossIcon}</p>

              {confirmAction ? (
                <>
                  <p>Remove Report</p>
                  <p>Are you sure you want to {confirmAction === "delete"
                    ? "Delete Report"
                    : "Hibernate Report"}?</p>
                  <p>

                  </p>

                  <p style={{ color: 'red' }}>
                    The corresponding alerts you have created in the Alert table
                    will be paused.
                  </p>


                  <div>
                    <Button
                      style={{ background: "white" }}
                      onClick={() => setConfirmAction(null)}
                      value="Cancel"
                    />

                    <Button
                      onClick={() => {
                        if (confirmAction === "delete") {
                          handleRemove();

                        } else {
                          handleHibernate();
                        }
                        setConfirmAction(null);
                      }}
                      value="Confirm"
                    />
                  </div>
                </>
              ) : (
                <>
                  <p>Remove Report</p>
                  <p>Are you sure you want to remove the Report?</p>
                  <span>This action cannot be undone</span>

                  <div>
                    <Button
                      style={{ background: "white" }}
                      onClick={handleClosePopup}
                      value="Cancel"
                    />

                    {value?.showHibernate !== true && (
                      <Button
                        data-testid="handleHibrate"
                        onClick={() => handleChangeStatus("Hibernated", val)}
                        value={val === "Hibernated" ? "Active" : "Hibernate"}
                      />
                    )}

                    <Button
                      data-testid="handleRemove"
                      onClick={() => handleChangeStatus("delete", "delete")}
                      value="Delete"
                    />
                  </div>
                </>
              )}
            </DeletePopupWrapper>

          )}
        </PopUp>
      )}
      {
        // val !== 'Hibernated' &&

        <TabWrapper bgchange={bgchange} setActive={{ activeTab, id }}>
          {!subTabs && (
            <div onClick={() => handleScreen()}>
              {val}
              {activeTab !== id && <KeyboardArrowDownIcon />}
              {activeTab === id && <KeyboardArrowRightTwoToneIcon />}
            </div>
          )}
          {val === 'Active' && (
            <NewChatterTab
              key='newChatter'
              onClick={handleNewChatter}
              isClicked={isClicked}
              style={{marginBottom:'0px'}}
            >
              {buttonTitle}
              {name === 'Competitive Analysis'
                ? CompetitiveAnalysis
                : StyledAddIcon}
            </NewChatterTab>
          )}
          {subTabs && (
            <Type2Wrapper setActive={{ activeTab, id }} style={{ background: (personalDetailsData?.is_custom == 'custom' && personalDetailsData?.sidebar_navigation) ? personalDetailsData?.sidebar_navigation : 'rgb(240 255 240)' }}>


              <Header onClick={() => setShowDropDown(prev =>
                    prev === 'Active'
                      ? 'Hibernated'
                      : 'Active'
                  )}>

                {val}
                {` (${(subTabs?.length || 0).toString().padStart(2, '0')})`}
                <span 
                // onClick={() =>
                //   setShowDropDown(prev =>
                //     prev === 'Active'
                //       ? 'Hibernated'
                //       : 'Active'
                //   )
                // }
                  style={{
                    transform: showDropDown === val ? 'rotate(0deg)' : 'rotate(180deg)'
                  }}
                >{GreenDownArrowIcon}</span>

                {/* {activeTab !== id && <KeyboardArrowDownIcon />}
            {activeTab === id && <KeyboardArrowRightTwoToneIcon />} */}
              </Header>
              {
                showDropDown == val &&

                <Tab3Wrapper setActive={setActiveState}>
                  {subTabs && (
                    <SearchBar
                      type='text'
                      placeholder='Search...'
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  )}
                  {/* <Line /> */}
                  {/* activeTab === id && */}
                  {
                    <ScrollableWrapper setActive={setActiveState}>
                      <div>
                        {filteredSubTabs.map(
                          ({ id, val, type, channel, path, search_type }, index) => (
                            <Type2TabDiv
                              zindexActive={zindexActive}
                              onMouseLeave={() => setIsOpen(false)}
                            >
                              <Type2Tabs
                                style={{ padding:name == 'Competitive Analysis' ? '0px 5px' : '' }}
                                className='tabWith1'
                                data-tooltip-id="tooltip"
                                data-tooltip-html={channel === "instagram" && search_type === "hashtag"
                                  ? `( # ) ${val}`
                                  : channel === "instagram" && search_type === "user"
                                    ? `<span style="display:flex; align-items:center; gap:6px; color:white;">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="white">
                                      <path d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z"/>
                                    </svg>
                                    ${val}
                                  </span>`
                                    : val}
                                key={id}
                                onMouseEnter={() => setIsHovered(id)}
                                onMouseLeave={() => setIsHovered(false)}
                                onClick={() => handleScreen(index, id, path)}
                                onDoubleClick={() => handleEditName(id, val)}
                                setSubTabActive={{ active: active.subTab, id }}
                              >
                                {channel &&
                                  (name === 'Chatter Tracker' ? (
                                    channel == 'amazon' ? (
                                      <Icon>{AmazonIconSmall} </Icon>
                                    ) : (
                                      <Icon>{FlipkartIconSmall} </Icon>
                                    )
                                  ) : channel === 'twitter' ? (
                                    <Icon>{X_icon}</Icon>
                                  ) : channel === 'news' ? (
                                    <Icon>{NewsLogo}</Icon>
                                  ) : channel === 'facebook' ? (
                                    <Icon>{FacebookLogo}</Icon>
                                  ) : channel === 'youtube' ? (
                                    <Icon>{YouTubeRedIcon}</Icon>
                                  ) : channel === 'instagram' ? (
                                    <Icon>{InstagramIconSmall}</Icon>
                                  ) : <></>
                                  )}

                                <TransformTextStyle>
                                  {
                                    editTitle == id ?
                                      <input
                                        ref={inputRef}
                                        value={renameText}
                                        onChange={(e) => setRenameText(e.target.value)}
                                        onKeyDown={(e) => {
                                          if (e.key === "Enter") {
                                            handleRenameSubmit(id || "");
                                            setEditTitle(null);
                                          }
                                        }}
                                        onClick={(e) => e.stopPropagation()}

                                      />
                                      :
                                      transformText(val)
                                  }

                                </TransformTextStyle>
                                {type === 'add' && StyledAddIcon}
                                {/*  {type !== 'add' && active.subTab !== id && (
                      <KeyboardArrowDownIcon />
                    )} */}
                                {type !== 'add' && active.subTab === id && (
                                  <KeyboardArrowRightTwoToneIcon />
                                )}

                              </Type2Tabs>

                              <div className="tooltip">
                                {channel === "instagram" && search_type === "user" ? (
                                  <>
                                    <AccountCircle style={{ color: "white", fontSize: 14 }} />
                                    {val}
                                  </>
                                ) : channel === "instagram" && search_type === "hashtag" ? (
                                  `( # ) ${val}`
                                ) : (
                                  val
                                )}
                              </div>
                              {/* </Tooltip> */}
                              {
                                // isHovered && isHovered === id &&
                                <div className='threedots'>
                                  <CrossButton
                                    isOpen={isOpen}
                                    setIsOpen={setIsOpen}
                                    // isOpen={openId === id}   // ✅ ONLY open for this row
                                    // setIsOpen={(val) => setOpenId(val ? id : null)} // ✅ map to id
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleDeleteSubTab(id);
                                    }}
                                    onRename={(e) => {
                                      e.stopPropagation();
                                      handleEditName(id, val)
                                    }}
                                  />

                                </div>

                              }
                            </Type2TabDiv>

                          )
                        )}
                      </div>
                    </ScrollableWrapper>
                  }
                </Tab3Wrapper>
              }
            </Type2Wrapper>
          )}
        </TabWrapper>
      }
    </>
  );
};

export default Tabs;
